import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down('md')]: {
      alignItems: 'initial',
      marginBottom: theme.spacing(0.5),
    },
    [theme.breakpoints.downLandscape('md')]: {
      alignItems: 'initial',
      marginBottom: theme.spacing(0.5),
    },
  },
  icon: {
    marginRight: 8,
    '& path': {
      stroke: '#1E1E1E',
    },
    [theme.breakpoints.down('md')]: {
      marginTop: 4,
    },
    [theme.breakpoints.downLandscape('md')]: {
      marginTop: 4,
    },
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: 'auto',
    marginRight: '10px',
    width: 138,
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    [theme.breakpoints.downLandscape('md')]: {
      width: '100%',
    },
  },
  monthTitle: {
    [theme.breakpoints.down('lg')]: {
      fontSize: 18,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
      width: '80%',
    },
    [theme.breakpoints.downLandscape('md')]: {
      fontSize: 14,
      width: '80%',
    },
  },
  monthMessage: {
    fontSize: 18,
    lineHeight: '22px',
    width: '65%',
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
      lineHeight: '16px',
      paddingLeft: theme.spacing(2.5),
      width: '100%',
    },
    [theme.breakpoints.downLandscape('md')]: {
      fontSize: 12,
      lineHeight: '16px',
      paddingLeft: theme.spacing(2.5),
      width: '100%',
    },
  },
}));
